import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load theme preference from user settings
    const loadThemePreference = async () => {
      try {
        document.body.classList.add('dark');
        document.body.classList.remove('light');
        // const response = await api.get('/users/settings');
        // const { theme: savedTheme } = response.data;
        // if (savedTheme) {
        //   setTheme(savedTheme); 
        //   document.documentElement.classList.toggle('dark', true); // savedTheme === 'dark');
        // }
        
      } catch (error) {
        console.error('Failed to load theme preference:', error);
      } finally {
        setLoading(false);
      }
    };

    loadThemePreference();
  }, []);

  const toggleTheme = async () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    try {
      document.documentElement.classList.toggle('dark', true);
      // Update theme in user settings
      await api.put('/users/settings', { theme: newTheme });
      setTheme(newTheme);
      document.documentElement.classList.toggle('dark', newTheme === 'dark');
    } catch (error) {
      console.error('Failed to update theme preference:', error);
    }
  };

  const value = {
    theme,
    toggleTheme,
    loading
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}; 